// MA-851 — the demotion valve of the reading placement floor, as the /play/foundation guard and the Journey
// tap read it. The ranker (progression.placementValveLowered) lowers the valve when the child plateaus or
// fails on the FLOOR skill; while it is lowered the guard lets the floor skill's own prerequisites through
// (placementFloor.guardAllowsBelowFloor), so the easier skill the ranker picks is the skill Today names, the
// CTA opens and a tap launches. The guard route has only the device's local attempt mirror, which is what
// this reads (the mission itself merges cloud + local; on a device with the local mirror intact they agree).
import { belowFloor, type FloorProgressLike } from "./evidenceFloor";
import { aggregatePathSkillStatesFromAttempts, placementValveLowered } from "./progression";
import { loadLocalAttempts } from "./localAttemptStore";
import type { ChildAttempt } from "@/adaptation/types";

/** Pure: is the reading floor's valve lowered for this child, given their attempts? */
export function floorValveLowered(
  progress: FloorProgressLike | null | undefined,
  registryAge: number | null | undefined,
  attempts: readonly ChildAttempt[],
): boolean {
  const floor = belowFloor("reading", progress, registryAge);
  if (!floor) return false;
  const states = aggregatePathSkillStatesFromAttempts(attempts.filter((a) => a.skillId === floor.skillId) as ChildAttempt[]);
  return placementValveLowered(floor, states);
}

/** The same, reading the device's local attempt mirror for `localChildId`. */
export function floorValveLoweredForChild(
  localChildId: string | null | undefined,
  progress: FloorProgressLike | null | undefined,
  registryAge: number | null | undefined,
): boolean {
  if (!localChildId) return false;
  return floorValveLowered(progress, registryAge, loadLocalAttempts(localChildId, 500));
}
